import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ToolbarPopupPluginViewComponentBase } from '@portal-core/text-editor/plugin-views/util/toolbar-popup-plugin-view-component.base';

@Component({
  selector: 'mc-node-toolbar-popup-plugin-view',
  templateUrl: './node-toolbar-popup-plugin-view.component.html',
  styleUrls: ['./node-toolbar-popup-plugin-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodeToolbarPopupPluginViewComponent extends ToolbarPopupPluginViewComponentBase {
  @Input() isEditable: boolean;
  @Output() openNode: EventEmitter<void> = new EventEmitter<void>();

  onOpenNode() {
    this.openNode.emit();
  }
}
